import React from 'react';
import { VimeoVideo } from '@components/VimeoVideo';
import { ValuePropsArg, ValuePropsSection } from '@components/ValuePropsSection';
import {
  HeroVideoContainer,
  HeroVideoWrapper,
  HeroVideoOverlay,
  StyledSection,
  DisplayOnMobile,
  DisplayAboveMobile,
  HeroTextColumn,
  HeroTextPairing,
} from './HeroSectionWithProps.styles';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

export const HeroSectionWithProps: React.FC<{
  page: MarcomPageName | undefined;
  sectionId: string;
  ctaButtonId: string;
  heroData: { posterUrl: string; videoUrl: string; title: string; eyebrow: string; cta: string };
  valueProps: ValuePropsArg[];
  valuePropsMobile: ValuePropsArg[];
  valuePropsElementId: string;
}> = ({ sectionId, ctaButtonId, page, heroData, valueProps, valuePropsMobile, valuePropsElementId }) => {
  const { posterUrl, videoUrl, title, eyebrow, cta } = heroData;
  return (
    <>
      <StyledSection as="section" id={sectionId}>
        <HeroVideoContainer>
          <HeroVideoWrapper>
            <HeroVideoOverlay />
            <VimeoVideo
              posterUrl={posterUrl}
              isEagerLoading
              embedUrl={videoUrl}
              title={title}
              autoPlay
              background
              controls={false}
              autoPause={false}
              alt={title}
              muted
              loop
              cover
              posterOptimization="aggressive"
            />
          </HeroVideoWrapper>
        </HeroVideoContainer>
        <HeroTextColumn verticalAlign="center">
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} alignItems="center">
              <HeroTextPairing
                title={title}
                titleVariant="hed72Hero"
                titleColor="mono7"
                titleTagName="h1"
                alignment="center"
                eyebrow={eyebrow}
                eyebrowColor="mono7"
                eyebrowVariant="sectionEyeBrow20"
              >
                <Flex marginTop={7}>
                  <GetStartedButton variant="defaultPrimeWeddingWebsites" id={ctaButtonId} page={page}>
                    {cta}
                  </GetStartedButton>
                </Flex>
              </HeroTextPairing>
            </Flex>
          </Columns.Column>
        </HeroTextColumn>
      </StyledSection>
      <DisplayAboveMobile>
        <ValuePropsSection values={valueProps} elementId={valuePropsElementId} maxWidth="1032px" />
      </DisplayAboveMobile>
      <DisplayOnMobile>
        <ValuePropsSection values={valuePropsMobile} elementId={valuePropsElementId} />
      </DisplayOnMobile>
    </>
  );
};
